import React from 'react';
import {
  CardBackground,
  CardSize,
  TeaserCard as TeaserCardLib,
} from '@sparknz/spark-pattern-library';
import { LinkRegion, trackCustomLink } from '@sparknz/tracking';

import extractCQStyle, { CQStyleMap } from 'shared/utils/extractCQStyle';
import { TeaserCardEditConfig, TeaserCardProps } from './TeaserCardEditConfig';

export type TeaserCardIconColor = 'color' | 'isInverse';

const teaserCardIconColorCQStyleMap: CQStyleMap<TeaserCardIconColor> = {
  'teasercard-iconColor--color': 'color',
};

const teaserCardContentSizeCQStyleMap: CQStyleMap<CardSize> = {
  'teasercard-size--standard4': 'standard4',
  'teasercard-size--standard6': 'standard6',
  'teasercard-size--feature4': 'feature4',
  'teasercard-size--feature6': 'feature6',
  'teasercard-size--long': 'long',
};

const teaserCardBackgroundStyleCQStyleMap: CQStyleMap<CardBackground> = {
  'teasercard-backgroundStyle--basic': 'basic',
  'teasercard-backgroundStyle--rich': 'rich',
};

const TeaserCard = (props: TeaserCardProps) => {
  if (TeaserCardEditConfig.isEmpty(props)) {
    return null;
  }

  const {
    bgImagePath,
    featureImagePath,
    featureImageAlt,
    imagePath,
    title,
    link,
    description,
    appliedCssClassNames: cssClassNames,
    disabled,
    alt,
    regionId = 'teaserCard',
  } = props;

  const shouldOpenNew = link?.attributes?.target === '_blank';

  const iconColorStyle =
    extractCQStyle(teaserCardIconColorCQStyleMap, cssClassNames) || 'none';

  const cardSizeStyle =
    extractCQStyle(teaserCardContentSizeCQStyleMap, cssClassNames) ||
    'standard4';

  const cardBackgroundStyle =
    extractCQStyle(teaserCardBackgroundStyleCQStyleMap, cssClassNames) ||
    'basic';

  const handleClick = () => {
    trackCustomLink(title ?? '');
  };

  return (
    <LinkRegion regionId={regionId}>
      <TeaserCardLib
        tabIndex={0}
        bgImagePath={bgImagePath}
        featureImagePath={featureImagePath}
        featureImageAlt={featureImageAlt}
        imagePath={imagePath}
        description={description}
        title={title}
        linkURL={link?.url}
        iconColor={iconColorStyle}
        cardSize={cardSizeStyle}
        cardBackground={cardBackgroundStyle}
        disabled={disabled}
        onClick={handleClick}
        target={shouldOpenNew ? '_blank' : undefined}
        rel={shouldOpenNew ? 'noopener' : undefined}
        alt={alt || ''}
      />
    </LinkRegion>
  );
};

export default TeaserCard;
